import GetAllCustomersRequestModelBase from '../_generated/modelBases/get-all-customers-request-model-base';

export default class GetAllCustomersRequestModel extends GetAllCustomersRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
